import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const ChevronLeft = createIcon({
  displayName: "ChevronLeft",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Chevron Left Icon </title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8735 4.60647C16.0688 4.80173 16.0688 5.11831 15.8735 5.31358L9.18709 12L15.8735 18.6865C16.0688 18.8817 16.0688 19.1983 15.8735 19.3936C15.6783 19.5888 15.3617 19.5888 15.1664 19.3936L8.12643 12.3536C8.03266 12.2598 7.97998 12.1326 7.97998 12C7.97998 11.8674 8.03266 11.7402 8.12643 11.6465L15.1664 4.60647C15.3617 4.41121 15.6783 4.41121 15.8735 4.60647Z"
      />
    </>
  )
});
